<template>
  <v-alert
    :class="['reg-v-alert']"
    :value="alertToggle"
    :type="messageData.type"
    transition="scale-transition"
  >
    <span>{{ messageData.messageText }}</span>
    <!-- <v-btn
      v-if="!expireFlash && messageData.showRegisterButton"
      @click="redirectToRegister()"
      >{{ "lng_register_title" | translate }}</v-btn
    >-->
  </v-alert>
</template>
<script>
export default {
  data: () => ({
    timerInstance: undefined
  }),
  props: {
    messageData: {
      type: Object,
      default: () => {}
    },
    alertToggle: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.setFlashTimer();
  },
  beforeDestroy() {
    clearTimeout(this.timerInstance);
  },
  methods: {
    setFlashTimer() {
      this.timerInstance = setTimeout(() => {
        this.$emit("alertToggleUpdate");
      }, 5000);
    }
  }
};
</script>

<style scoped>
.reg-v-alert {
  padding: 4px 15px;
  border-color: rgba(0, 0, 0, 0.12) !important;
  position: fixed !important;
  top: 0;
  right: 5px;
  z-index: 7;
  border: 0;
  border-radius: 3px;
  min-width: 300px;
  font-size: 15px;
  color: #fff;
}
.reg-v-alert .v-btn {
  color: rgba(255, 255, 255, 0.87);
  background-color: rgb(84, 110, 122) !important;
}
</style>
